import React from "react";
import ContactForm from "../components/ContactForm";
import SiteLayout from "../components/SiteLayout";

const ContactPage = () => {
  return (
    <SiteLayout>
      <section className="page-hero">
        <div className="container page-hero__grid">
          <div>
            <p className="section-eyebrow">Contact</p>
            <h1>Get in touch</h1>
            <p className="lead">
              Reach out to Lizzie to discuss your hair goals, ask any questions you have about the services, or find out more about how the online colour analysis works.
            </p>
          </div>
          <div>
            <figure className="contact-hero-image">
              <img
                alt="Grey blending transformation by Lizzie Fox Colour Studio"
                src="/clientMedia/gb3.png"
              />
              </figure>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-panel">
            <div className="section-heading">
              <p className="section-eyebrow">Enquiry Form</p>
              <h2>Start the conversation</h2>
            </div>
            <ContactForm />
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default ContactPage;
